<template>
  <div class="postavke forma-erp">

    <!-- Gumbi su prije stajali u tri reda bez reda; sada su slozeni po tome
         cemu sluze, a ono sto smije samo glavni administrator je odvojeno. -->
    <v-card outlined class="mb-3">
      <v-card-title class="naslov-kartice">
        {{ lang.Sifrarnici }}
        <span class="dodatak">{{ lang.SifrarniciHint }}</span>
      </v-card-title>
      <v-card-text class="tijelo">
        <div class="gumbi">
          <v-btn small color="primary" @click="warehousemark">{{ lang.Warehouse }}</v-btn>
          <v-btn small color="primary" @click="warehouseuser">{{ lang.WarehouseUser }}</v-btn>
          <v-btn small color="primary" @click="bankaccount">{{ lang.BankAccount }}</v-btn>
          <v-btn small color="primary" @click="calendar">{{ lang.Calendar }}</v-btn>
          <v-btn small color="primary" @click="docdescs">{{ lang.DocDesc }}</v-btn>
          <v-btn small color="primary" @click="vehicles">{{ lang.Vehicles }}</v-btn>
          <v-btn small color="primary" @click="klasus">Klasus</v-btn>
          <v-btn small color="primary" @click="termsofuse">{{ lang.Terms }}</v-btn>
        </div>
      </v-card-text>
    </v-card>

    <v-card outlined class="mb-3" v-if="admin || fullAdmin">
      <v-card-title class="naslov-kartice">
        {{ lang.PostavkeFirme }}
        <span class="dodatak">{{ lang.PostavkeFirmeHint }}</span>
      </v-card-title>
      <v-card-text class="tijelo">
        <div class="gumbi">
          <v-btn small color="primary" @click="companyedit">{{ lang.Logo }}</v-btn>
          <v-btn small color="primary" @click="companybusinessyear">{{ lang.CompanyBusinessYear }}</v-btn>
          <v-btn small color="primary" @click="companyuser">{{ lang.CompanyUsers }}</v-btn>
          <v-btn small color="primary" @click="cardtype">{{ lang.CardType }}</v-btn>
          <!-- Teya se povezuje po firmi i radi se jednom, pa stoji ovdje,
               a ne u glavnom izborniku. -->
          <v-btn small color="primary" @click="teyapostavke">Teya aparat</v-btn>
          <v-btn small color="primary" @click="user" v-if="admin">{{ lang.Users }}</v-btn>
        </div>
      </v-card-text>
    </v-card>

    <!-- Sve ispod mijenja podatke izvan jedne firme ili otkljucava vec
         zakljucane dokumente, pa stoji odvojeno i s upozorenjem. -->
    <v-card outlined class="mb-3 kartica-admin" v-if="fullAdmin">
      <v-card-title class="naslov-kartice naslov-admin">
        <v-icon small color="white" class="mr-1">mdi-shield-account</v-icon>
        {{ lang.SamoGlavniAdmin }}
        <span class="dodatak-admin">{{ lang.SamoGlavniAdminHint }}</span>
      </v-card-title>
      <v-card-text class="tijelo">
        <div class="gumbi mb-4">
          <v-btn small color="primary" @click="company">{{ lang.Company }}</v-btn>
          <v-btn small color="primary" @click="companycreateuser">{{ lang.NovaFirma }}</v-btn>
          <v-btn small outlined color="primary" @click="unlock">{{ lang.UnlockERacun }}</v-btn>
        </div>

        <div class="podnaslov">{{ lang.SkupneObrade }}</div>
        <div class="gumbi">
          <div style="max-width:110px">
            <v-text-field
              dense
              outlined
              hide-details
              label="Godina"
              v-model="yearToFill"
              type="number"
            ></v-text-field>
          </div>
          <v-btn small outlined color="primary" @click="updatedocdoc">Kalendar napuni</v-btn>
          <v-btn small outlined color="primary" @click="updategrupe">Up.grupe u doc.det.</v-btn>
        </div>
      </v-card-text>
    </v-card>

    <div  v-if="showDocumentUnlock"> 
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
          <span class="headline">Otključavanje eRačuna </span>
        </v-col>      
      </v-row>
      <v-row> 
        <v-col cols="12" sm="2" md="2" lg="2" xl="2">
            <v-text-field
              dense
              label="Broj računa"
              v-model="documentId"
              type="number"
              v-if="fullAdmin"
              outlined
            ></v-text-field>
            <v-btn color="primary" @click="showInvoice" class="mr-2" :disabled="haveInvoice">
              Prikaži
            </v-btn> 
            <span v-if="haveInvoice"> <v-btn color="primary" @click="markUlocked" class="mr-2">
              Otključaj
            </v-btn> 
            </span>
        </v-col>
      </v-row>
      <div v-if="haveInvoice">
        <v-row>
          <v-col cols="12" sm="4" md="4" lg="4" xl="4">
            <DocumentViewCard1 />
          </v-col> 
        </v-row> 
        <v-row>
          <v-col cols="12" sm="4" md="4" lg="4" xl="4">
            <DocumentViewCard2 />
          </v-col> 
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" md="4" lg="4" xl="4">
            <DocumentViewCard3 />
          </v-col>     
        </v-row>
      </div>
    </div> 
    <v-row no-gutters v-if="showTerms">    
      <v-col cols="12" sm="10" md="10" lg="10" xl="10">
        <CompTermsOfUse />
      </v-col>
    </v-row> 
    <v-row no-gutters v-if="showVehicle">    
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <Vehicle />
      </v-col>
    </v-row>
    <v-row no-gutters v-if="showDocDesc">    
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <DocDesc />
      </v-col>
    </v-row>
    <div v-if="showDialog">
        <Dialog :header="header" :message="message" :dcolor="dcolor" />
    </div>
  </div>
</template>

<script>
import langEn from './mainDescEN'
import langHr from './mainDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import DocumentService from '@/services/DocumentService'
import DocumentDetailService from '@/services/DocumentDetailService'
import CompTermsOfUse from '@/components/Companies/CompTermsOfUse'
import Vehicle from '@/components/Vehicle/VehicleIndex'
import DocDesc from '@/components/DocDesc/DocDescIndex'
import DocumentViewCard1 from '@/components/Document/DocumentViewCard1'
import DocumentViewCard2 from '@/components/Document/DocumentViewCard2'
import DocumentViewCard3 from '@/components/Document/DocumentViewCard3'
import Dialog from '@/snippets/Dialog'
import { f } from 'pdfmake/build/pdfmake'

export default {
  name: 'appsettings',
  data () {
    return {
      menu: false,
      modal: false,
      msg: '',
      valid: true,
      account: { },
      error: null,
      localError: false,
      privGroups: [],
      lang: {},
      langC: {},
      saving: false,
      admin: false,
      showTerms: false,
      showBeton: false,
      showTvrtka: false,
      showKorisnik: false,
      showObjekt: false,
      showVehicle: false,
      showDocDesc: false,
      mainQuery: {},
      userIsBeton: false,
      fullAdmin: false,
      yearToFill: new Date().getFullYear(),
      showDocumentUnlock: false,
      invoiceNr: 0,
      showDetailInvoice: false,
      eRacunDialog: false,
      showDialog: false,
      dcolor: 'success',
      header: '',
      message: '',
      documentId: 0,
      haveInvoice: false

    }
  },
  components: {
    CompTermsOfUse,
    Vehicle,
    DocDesc,
    DocumentViewCard1,
    DocumentViewCard2,
    DocumentViewCard3,
    Dialog
  },
  async mounted () {
    if (this.$store.state.language === "EN") {
        this.lang = langEn
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.lang = langHr
        this.langC = commHr;
      }

      // Kad sesija istekne, "user" u storeu je null - citanje ".Admin" tada
      // baci gresku i cijeli ekran postavki ostane prazan.
      const korisnik = this.$store.state.user ? this.$store.state.user : {}
      this.fullAdmin = korisnik.Admin === true
      this.admin = korisnik.admin2 === true
      this.userIsBeton = korisnik.beton ? korisnik.beton : false
  },
  methods: {
    termsofuse(){
      this.showTerms = !this.showTerms
    },
    vehicles() {
      this.showVehicle = !this.showVehicle
    },
    docdescs() {
      this.showDocDesc = !this.showDocDesc
    },
    unlock() {
      this.haveInvoice = false
      this.showDocumentUnlock = !this.showDocumentUnlock
    },
    reseteRacunDialog() {
      this.$store.dispatch('setDocumentActivHead', {})
      this.$store.dispatch('setDocumentActivItems', [])
      this.showDocumentUnlock = false
      this.invoiceNr = 0
      this.showDetailInvoice = false
    },
    async showInvoice () {
      try {
        this.dcolor = 'success'
        this.haveInvoice = false
        let notSet = true
        this.$store.dispatch('setDocumentActivHead', {})
        this.showDialog = false
        this.$store.dispatch('setDialogState', false)
        const query = {}
        query.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
        query.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2021
        query.documentName = 'InvoiceSales'
        query.documentId = this.documentId ? parseInt(this.documentId) : 0
        // find invoice and show 
        const dbDocument = await DocumentService.onlyoneneed(query)
        if (dbDocument && dbDocument.data && dbDocument.data.document) {
          notSet = false
          const docLocked = dbDocument.data.document.documentLocked
          if (docLocked) {
            this.$store.dispatch('setDocumentActivHead', dbDocument.data.document)
            console.log('dbDocument.data.document', dbDocument.data.document)
            this.haveInvoice = true
          }
          if (!docLocked) {
            this.dcolor = 'error'
            this.header = ' Error!'
            this.message = 'Error Invoice is not locked. Greška, račun s tim brojem nije zaključan!'
            this.showDialog = true
            this.$store.dispatch('setDialogState', true)
            this.$store.dispatch('setDocumentActivHead', {})
          }
        } 

        if (notSet) {
          this.dcolor = 'error'
          this.header = ' Error!'
          this.message = 'Error Invoice not exist. Greška, račun s tim brojem ne postoji!'
          this.showDialog = true
          this.$store.dispatch('setDialogState', true)
          this.$store.dispatch('setDocumentActivHead', {})
        }
          
      } catch (error) {
        console.log(error)
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = 'Error on search invoice! Greška kod traženja računa!'
        this.showDialog = true
        this.$store.dispatch('setDialogState', true)
      }
    },
    async markUlocked() {
      try {
        const doc = this.$store.state.documentActivHead
        doc.documentLocked = false
        doc.documentLockedDate = null
        doc.documentLockedTime = null
        doc.documentLockedBy = null
        doc.RespondedStatus = null
        doc.documentUpdateBy = this.$store.state.user.email ? this.$store.state.user.email : ''
        const resp = await DocumentService.put(doc)
        if (resp && resp.data) {
          this.haveInvoice = false
          this.$store.dispatch('setDocumentActivHead', {})
          this.dcolor = 'success'
          this.header = ' OK!'
          this.message = 'Ulocked! Otkljucan!'
          this.showDialog = true
        }
      } catch (error) {
        console.log(error)
        this.dcolor = 'error'
        this.header = ' Error!'
        this.message = 'Error on search invoice! Greška kod traženja računa!'
        this.showDialog = true
        this.$store.dispatch('setDialogState', true)
      }
    },
    async klasus () {
      try {
        await this.$router.push({
          name: 'klasus'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async warehousemark () {
      try {
        await this.$router.push({
          name: 'warehousemark'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async warehouseuser () {
      try {
        await this.$router.push({
          name: 'warehouseuser'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async user () {
      try {
        await this.$router.push({
          name: 'user'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async bankaccount () {
      try {
        await this.$router.push({
          name: 'bankaccount'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async calendar () {
      try {
        await this.$router.push({
          name: 'calendar'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async company () {
      try {
        await this.$router.push({
          name: 'company'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async company () {
      try {
        await this.$router.push({
          name: 'company'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async companycreateuser () {
      try {
        await this.$router.push({
          name: 'companycreateuser'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async companyedit () {
      try {
        await this.$router.push({
          name: 'companyedit'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async companybusinessyear () {
      try {
        await this.$router.push({
          name: 'companybusinessyear'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async companyuser () {
      try {
        await this.$router.push({
          name: 'companyuser'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async cardtype () {
      try {
        await this.$router.push({
          name: 'cardtype'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async teyapostavke () {
      try {
        await this.$router.push({
          name: 'TeyaPostavke'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async updatedocdoc () {
      try {
        const yearTofill = {
          year: this.yearToFill
        }
        await DocumentService.updatedocdoc(yearTofill)
        alert('Kalendar napunjen!')
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async updategrupe () {
      try {
        const itemsLoc = this.$store.state.itemStore ? this.$store.state.itemStore : []
        this.mainQuery.BusinessYear = this.$store.state.businessYear
        const needUpdate = []
        this.mainQuery.CompanyId = this.$store.state.companyid
        this.mainQuery.docFromDate = new Date(new Date().getFullYear(), 0, 1)
        this.mainQuery.docToDate = new Date(new Date().getFullYear(), 11, 31)


        await DocumentDetailService.salesana(this.mainQuery)
        .then(res => {
          const itemDetails = res.data.document ? res.data.document : []
          console.log('Sve stavke u dok.detalis ', itemDetails)
          if (itemDetails) {
            itemDetails.map(item=> {
              if (!item.itemGroup || !item.itemGroupName) {
                let addItem = true
                if (needUpdate) {
                  const marked = needUpdate.find(nitem => {nitem.itemID === item.itemID})
                  if (marked) {
                    addItem = false
                  }
                }
                if (addItem) {
                  const haveItem = itemsLoc.find(fitem => fitem.itemID === item.itemID)
                  const newItem = {}
                  newItem.CompanyId = this.$store.state.companyid
                  newItem.BusinessYear = this.$store.state.businessYear
                  newItem.itemID = item.itemID
                  newItem.GroupId = haveItem.GroupId
                  newItem.GroupName = haveItem.GroupName
                  needUpdate.push (newItem)
                }
              }
            })
          }
          console.log('Trebaju update  ', needUpdate)
          if (needUpdate) {
            needUpdate.map(async(upitem) => {
              await DocumentDetailService.updateitems(upitem)
            })
          }
          console.log('Update done  !!')
        })
        .catch((err) => {
          console.log(err)
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },

  },
  computed: {
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.postavke { padding: 10px 14px; }

.postavke .naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1976d2;
  padding: 8px 16px;
  min-height: 0;
  gap: 8px;
}
.postavke .naslov-kartice .dodatak {
  font-size: 12px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}

/* Radnje glavnog administratora izlaze iz okvira jedne firme, pa se i
   vizualno odvajaju od ostatka postavki. */
.postavke .kartica-admin {
  border-color: #ef9a9a;
}
.postavke .naslov-admin {
  color: #fff;
  background: #c62828;
  border-bottom-color: #8e0000;
}
.postavke .naslov-admin .dodatak-admin {
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
}

.postavke .tijelo {
  padding: 14px 16px 16px;
}
.postavke .gumbi {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.postavke .podnaslov {
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.75);
  margin-bottom: 8px;
}
</style>
